export default __webpack_public_path__ + "static/media/calendar time.eba7a055.svg";